import ReactMarkdown from 'react-markdown'
import rehypeExternalLinks from 'rehype-external-links'
import rehypeRaw from 'rehype-raw'
import rehypeSlug from 'rehype-slug'
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '#app/components/ui/accordion'
import { type FAQData } from '#app/routes/_publicWithoutSidebar+/$country+/$administration.$procedureId.tsx'

export default function ProcedureFAQs(props: {
	faqData: FAQData[]
	faqSchema: any
}) {
	const { faqData, faqSchema } = props
	return (
		<section className="mb-16">
			<hr className="mt-8" />
			<div className="prose my-8">
				<h2 id="preguntas-frecuentes">Preguntas frecuentes</h2>
			</div>
			<div>
				<Accordion type="single" collapsible>
					{faqData.map((faq, i) => (
						<AccordionItem
							key={i}
							value={`item-${i}`}
							className="border-b border-gray-200"
						>
							<AccordionTrigger className="text-lg font-bold text-[rgb(var(--text-primary))] hover:no-underline">
								{faq.question}
							</AccordionTrigger>
							<AccordionContent>
								<div className="prose prose-a:font-semibold prose-a:text-amber-700 prose-a:no-underline prose-a:hover:text-amber-400 mt-6 max-w-prose">
									<ReactMarkdown
										rehypePlugins={[
											rehypeSlug,
											rehypeRaw, // Enables rendering of raw HTML
											[
												rehypeExternalLinks,
												{ target: '_blank', rel: 'noopener noreferrer' },
											], // Properly configured external links
										]}
										components={{
											a: ({ href, children }) => {
												const isExternal = href?.startsWith('http')
												return (
													<a
														href={href}
														target={isExternal ? '_blank' : undefined}
														rel={isExternal ? 'noopener noreferrer' : undefined}
													>
														{children}
													</a>
												)
											},
										}}
									>
										{faq.answer}
									</ReactMarkdown>
								</div>
							</AccordionContent>
						</AccordionItem>
					))}
				</Accordion>

				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
				/>
			</div>
		</section>
	)
}
